<!-- Tour Overlay Container -->
<div class="tour-overlay" *ngIf="tourState?.isActive && currentStep">
  <!-- Spotlight backdrop with cutout -->
  <div class="tour-backdrop"></div>
  
  <!-- Tour Tooltip -->
  <div class="tour-tooltip" #tourTooltip>
    <!-- Progress Bar -->
    <div class="tour-progress">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="getProgressPercentage()"></div>
      </div>
      <span class="progress-text">{{ getStepProgress() }}</span>
    </div>
    
    <!-- Tour Content -->
    <div class="tour-content">
      <div class="tour-header">
        <h3 class="tour-title">{{ currentStep.title }}</h3>
        <button class="tour-close" (click)="onClose()" title="Close tour">
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <div class="tour-body">
        <p class="tour-description">{{ currentStep.content }}</p>
      </div>
      
      <!-- Tour Actions -->
      <div class="tour-actions">
        <div class="tour-nav">
          <button 
            class="tour-btn tour-btn-secondary" 
            *ngIf="currentStep.showPrevious"
            (click)="onPrevious()"
            [disabled]="tourState?.currentStep === 0">
            <i class="fas fa-arrow-left"></i>
            Previous
          </button>
          
          <button 
            class="tour-btn tour-btn-primary" 
            *ngIf="currentStep.showNext"
            (click)="onNext()">
            Next
            <i class="fas fa-arrow-right"></i>
          </button>
          
          <!-- Final step button -->
          <button 
            class="tour-btn tour-btn-success" 
            *ngIf="!currentStep.showNext"
            (click)="onNext()">
            <i class="fas fa-check"></i>
            Got it!
          </button>
        </div>
        
        <button 
          class="tour-skip" 
          *ngIf="currentStep.showSkip"
          (click)="onSkip()">
          Skip tour
        </button>
      </div>
    </div>
    
    <!-- Tooltip Arrow -->
    <div class="tour-arrow" [ngClass]="'arrow-' + currentStep.position"></div>
  </div>
</div> 